import { render, staticRenderFns } from "./order.vue?vue&type=template&id=2f5d6e4b&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=2f5d6e4b&prod&lang=css"
import style1 from "./order.vue?vue&type=style&index=1&id=2f5d6e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d6e4b",
  null
  
)

export default component.exports